/** Web public API auth path prefix (relative to web BASE_URL). */
export const WEB_AUTH_BASE_PATH = '/api/v1/auth';
/** Admin auth path prefix (relative to admin BASE_URL). */
export const ADMIN_AUTH_BASE_PATH = '/auth';
export const isWebPublicAuthPath = (url) => url.startsWith(`${WEB_AUTH_BASE_PATH}/sign-in`) ||
    url.startsWith(`${WEB_AUTH_BASE_PATH}/sign-up`) ||
    url.startsWith(`${WEB_AUTH_BASE_PATH}/verify-email`) ||
    url.startsWith(`${WEB_AUTH_BASE_PATH}/forgot-password`) ||
    url.startsWith(`${WEB_AUTH_BASE_PATH}/reset-password`) ||
    url.startsWith(`${WEB_AUTH_BASE_PATH}/refresh-token`);
export const isWebRefreshTokenPath = (url) => url.startsWith(`${WEB_AUTH_BASE_PATH}/refresh-token`);
export const isAdminPublicAuthPath = (url) => url === ADMIN_AUTH_BASE_PATH;
